<template>
	<div class="users-container">
		<div class="users">
			<LayoutBox class="users__section">
				<div class="users__header">
					<AppTextField
						class="users__search"
						icon-right="search"
						placeholder="Search"
						v-model="filters.searchKeyword"
						@input="search"
					/>
				</div>

				<h3 class="users__header">
					Filters
				</h3>

				<div class="users__header">
					<AppDropdown
						class="users__filter"
						placeholder="All"
						:options="activeLevels"
						v-model="filters.activeLevel"
					>
						Active level
					</AppDropdown>

					<AppDropdown
						class="users__filter"
						placeholder="All"
						display-prop="name"
						:options="countryList"
						:multiple="true"
                        :searchable="true"
						:loading="countryListLoading"
						v-model="filters.country"
					>
						Country
					</AppDropdown>

					<AppDropdown
						class="users__filter"
						placeholder="Select"
						:options="emotions"
						:multiple="true"
						v-model="filters.emotion"
					>
						Emotion
					</AppDropdown>

					<AppDropdown
						class="users__filter"
						placeholder="Select Gender"
						:options="genders"
						:multiple="true"
						v-model="filters.gender"
					>
						Gender
					</AppDropdown>

					<AppDropdown
						class="users__filter"
						placeholder="Select Device"
						:options="devices"
						:multiple="true"
						v-model="filters.device"
					>
						Device
					</AppDropdown>

					<!-- <AppDropdown
						class="users__filter"
						placeholder="Select age"
						:options="ages"
						v-model="filters.age"
					>
						Age
					</AppDropdown> -->
					<AppSliderRange
						:min="0"
						:max="150"
						v-model="filters.age"
					>
						Age
					</AppSliderRange>

					<AppDropdown
						class="users__filter"
						placeholder="Latest"
						:options="[...sortByItems,...sortTypeItems]"
						:value="filters.sortBy"
					>
						Sort by

						<template #option="{props}">
							<span
								v-if="sortByItems.includes(props.option)"
								class="sort"
								:class="{ 'sort--selected': props.option === filters.sortBy }"
								@click="setSortItem(props.option, 'sortBy')"
							>
								{{ props.option }}
							</span>

							<span
								v-if="sortTypeItems.includes(props.option)"
								class="sort"
								:class="{ 'sort--selected': props.option === filters.sortType,
										'sort--divider' : props.option === 'Ascending'}"
								@click="setSortItem(props.option, 'sortType')"
							>
								{{ props.option }}
							</span>
						</template>
					</AppDropdown>
				</div>

				<div class="users__header">
					<AppButton modifier="small-primary" @click="applyFilters">Apply</AppButton>
					<AppButton modifier="small-danger" @click="clearFilters">Clear</AppButton>
				</div>
			</LayoutBox>

			<LayoutBox class="users__section users__main">
				<div class="users__header">
					<AppCard class="users__filter-card" type="primary">
						<div class="filter">
							<h4>{{ card.total }}</h4>
							<p>Users</p>
						</div>
					</AppCard>
					<AppCard class="users__filter-card" type="primary">
						<div class="filter">
							<div>
								<label>
									Male
									<h4>{{ card.maleRatio || 0 }}</h4>
								</label>
								<label>
									Female
									<h4>{{ card.femaleRatio || 0  }}</h4>
								</label>
								<label>
									N/A
									<h4>{{ card.noneRatio || 0 }}</h4>
								</label>
								<label>
									Others
									<h4>{{ card.othersRatio || 0 }}</h4>
								</label>
							</div>
							<p>Gender</p>
						</div>
					</AppCard>
					<AppCard class="users__filter-card" type="primary">
						<div class="filter">
							<h4>{{ card.countryCount || 0 }}</h4>
							<p>No. of Countries</p>
						</div>
					</AppCard>
					<AppCard class="users__filter-card" type="primary">
						<div class="filter">
							<h4>{{ card.average_emotion || '--' }}</h4>
							<p>Average Emotion</p>
						</div>
					</AppCard>
				</div>

				<AppTable
					class="users__table"
					:fields="fields"
					:dataset="userList.data"
					:checkbox="false"
					:loading="userListLoading"
					@click="viewUser"
				>
					<template #loading>
						<AppLoading/>
					</template>
				</AppTable>

				<div class="users__pagination">
					<p>
						{{`${userList.from || ''}-${userList.to || ''}`}}
					</p>

					<AppCountPicker
						placeholder="Item"
						min="10"
						max="60"
						step="10"
						v-model="filters.itemsPerPage"
						:disabled="userListLoading"
						@change="getUserList"
					/>

					<AppPagination
						v-model="filters.page"
						:total="userList.last_page"
						:disabled="userListLoading"
						@change="getUserList(null,null,false)"
					/>
				</div>
			</LayoutBox>
		</div>
	</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import * as userModule from '@/store/user'
import UserFilter from '@/class/UserFilter'

export default {
	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['user/']) {
			this.$store.registerModule('user', userModule.default)
		}
	},

	async created () {
		this.$router.push(`users${this.lastQueryParams}`)
		await this.checkQuery()
		await this.applyFilters()
		await this.$store.dispatch('user/getCountryList')
	},

	data () {
		return {
			selected: [],
			option: [{ id: 2, text: 'Option2' }],

			filters: {
				page: 1,
				itemsPerPage: 10,
				searchKeyword: '',
				sortBy: '',
				sortType: '',
				activeLevel: '',
				country: [],
				gender: [],
				age: [0, 0],
				emotion: [],
				device: []
			},

			sortTypeItems: [
				'Ascending',
				'Descending'
			],

			sortByItems: [
				'Name',
				'Current Emotion',
				'Status',
				'Location'
			],

			activeLevels: [
				'All',
				'Online',
				'Offline'
			],

			genders: [
				'Male',
				'Female',
				'No Gender',
				'Others'
			],

			emotions: [
				'No Current Emotion',
				'Anxious',
				'Tense',
				'Calm',
				'Confused',
				'Excitement',
				'Happy',
				'Sad',
				'Pleasant',
				'Unpleasant',
				'Challenged',
				'Zen',
				'Loading'
			],

			devices: [
				'IOS',
				'Android',
				'Others'
			],

			fields: [
				{ name: 'id', text: 'User ID' },
				{ name: 'name', text: 'Name' },
				{ name: 'user_age', text: 'Age' },
				{ name: 'gender', text: 'Gender' },
				{ name: 'emotion_value', text: 'Emotion' },
				{ name: 'country', text: 'Location' },
				{ name: 'device_type', text: 'Device' },
				{ name: 'active_level', text: 'Active Level' }
			]
		}
	},

	methods: {
		applyFilters () {
			const { apiQuery, routerQuery } = new UserFilter(this.filters)
			this.getUserList(apiQuery, routerQuery)
			this.getCard(apiQuery)
		},

		getCard (payload) {
			this.$store.dispatch('user/getCard', payload)
		},

		async downloadExcel () {
			const { page } = this.filters
			const form = new FormData()
			form.append('page', page)
			await this.$store.dispatch('user/downloadUserListExcel', form)
		},

		viewUser ({ id }) {
			this.lastQueryParams = this.$route.fullPath.replace('/users', '')
			this.$router.push(`/user-profile/${id}`)
		},

		editItem (item) {
			console.log(item)
		},

		deleteItem (item) {
			console.log(item)
		},

		setSortItem (item, type) {
			const currentValue = this.filters[type]

			if (item === currentValue) {
				this.filters[type] = ''
			} else {
				this.filters[type] = item
			}

			// if (this.filters.sortType !== '') {
			// 	this.filters.page = 1
			// 	this.getUserList()
			// }
		},

		async getUserList (_api = null, _query = null, resetPage = true) {
			let api = _api
			let query = _query
			if (resetPage) this.filters.page = 1

			if (!query) {
				const { apiQuery, routerQuery } = new UserFilter(this.filters)
				api = apiQuery
				query = routerQuery
			}

			this.$store.dispatch('user/getUserList', api)
			this.$router.push({ query: query })
		},

		async checkQuery () {
			const {
				page,
				keyword,
				sort_type,
				age_from,
				age_to,
				emotion_value,
				device_type,
				gender,
				country,
				active_level,
				sort_by
			} = this.$route.query

			if (page) this.filters.page = parseInt(page)
			if (keyword) this.filters.searchKeyword = keyword
			if (sort_type) this.filters.sortType = sort_type
			if (sort_by) this.filters.sortBy = sort_by
			if (emotion_value) this.filters.emotion = emotion_value.split(',')
			if (device_type) this.filters.device = device_type.split(',')
			if (gender) this.filters.gender = gender.split(',')
			if (country) {
				country.split(',').forEach(x => {
					this.filters.country.push(this.countryList.filter(i => i.name === x)[0])
				})
			}
			if (active_level) this.filters.activeLevel = active_level
			this.filters.age = [age_from || 0, age_to || 0]
		},

		clearFilters () {
			this.lastQueryParams = ''

			this.filters = {
				page: 1,
				itemsPerPage: 10,
				searchKeyword: '',
				sortBy: '',
				sortType: '',
				activeLevel: '',
				country: [],
				gender: [],
				age: [0, 0],
				emotion: [],
				device: []
			}
			const { apiQuery } = new UserFilter(this.filters)
			this.getUserList()
			this.getCard(apiQuery)
		},

		async search (e) {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.filters.page = 1
				this.filters.searchKeyword = e
				this.getUserList()
			}, 500)
		},

		removeItem (index, type) {
			this.filters[type].splice(index, 1)
		}
	},

	computed: {
		hasFilter () {
			const {
				activeLevel,
				age,
				country,
				gender,
				emotion
			} = this.filters

			return !!(activeLevel.length ||
					age[0] ||
					age[1] ||
					country.length ||
					emotion.length ||
					gender.length ||
					Object.keys(this.card).length)
		},

		...mapGetters('user', {
			userList: 'getUserList',
			userListLoading: 'getUserListLoading',
			card: 'getCard',
			cardLoading: 'getCardLoading',
			downloadExcelLoading: 'getUserListExcelLoading'
		}),

		...mapFields('user', {
			countryList: 'countryList',
			countryListLoading: 'countryListLoading',
			countryKeyword: 'countryKeyword',
			lastQueryParams: 'lastQueryParams'
		})
	}
}
</script>

<style lang="scss" scoped>
.users {
	height: 100%;
	width: 100%;
	padding: 1.5em;
	display: flex;
	flex-direction: column;

	&__section {
		width: 100%;
		&:first-child { margin-bottom: .5px; }
	}

	&__main {
		flex: 1 1 auto;
		padding-top: 0;
		min-height: 0;
		display: flex;
		flex-direction: column;
		min-height: 300px;
	}

	&__header {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 10px;

		> *:not(:last-child) {
			margin-right: 10px;
			margin-left: auto;
		}
	}

	&__search {
		display: block;
		margin-left: auto;
		width: 250px;
	}

	&__filter {
		flex: 1 1 auto;
		max-width: 14%;

		.sort {
			white-space: nowrap;
			display: inline-block;
			position: relative;
			width: 100%;
			padding: 3px 0;

			&--divider:before {
				content: '';
				display: block;
				width: 100%;
				border-top: .5px dashed $default-light;
				position: absolute;
				top: -5px;
			}

			&--selected { color: $primary; }
			&--selected:hover { color: #fff; }
		}
	}

	&__filter-card {
		flex: 1 1 auto;
		min-width: 100px;

		.filter {
			height: 4em;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: flex-end;

			label, p { display: inline-block; }

			label {
				margin: 0 5px;
				color: $default-light;
			}

			h4 {
				color: $default;
				margin-bottom: .5em;
				text-align: center;
			}
		}
	}

	&__table {
		flex: 1 1 auto;
		margin-bottom: 10px;
		margin-top: 30px;
	}

	&__pagination {
		width: 100%;
		display: flex;
		align-items: center;

		> *:first-child { margin-right: auto; }
		> *:not(:first-child) { margin-left: 20px; }
	}
}
</style>
